<template>
  <DescriptionSection class="mx-6 my-4">
    <BaseTypography variant="subtitle">Szczegóły serwisu</BaseTypography>
    <DescriptionItem title="Status">
      <ride-status-chip-field v-model="ride.status" :statuses="editionRideStatuses" :readonly="true" />
    </DescriptionItem>
    <DescriptionItem title="Nazwa miejsca serwisu">
      {{ ride.serviceLocation.name }}
    </DescriptionItem>
    <DescriptionItem title="Adres miejsce serwisu">
      <span class="text-right">
        {{ ride.serviceLocation.address }}
      </span>
    </DescriptionItem>
    <DescriptionItem title="Data serwisu" :value="ride.scheduledAt | datetimeHourFirst" />
  </DescriptionSection>
</template>

<script>
import DescriptionSection from '@/component/Description/description-section';
import BaseTypography from '@/component/Base/base-typography';
import DescriptionItem from '@/component/Description/description-item';
import RideStatusChipField from '@/component/Field/TaxiCourse/ride-status-chip-field';
import { TAXI_COURSE_EDITION_RIDE_DICT, TAXI_COURSE_RIDE_DICT } from '@/core/dict/taxi-course-dict';

export default {
  name: 'ServiceRideGeneralInfo',
  components: {
    DescriptionSection,
    BaseTypography,
    DescriptionItem,
    RideStatusChipField,
  },
  props: {
    ride: Object,
  },
  computed: {
    editionRideStatuses() {
      const statuses = TAXI_COURSE_EDITION_RIDE_DICT.map(([value, text]) => ({ value, text, disabled: false }));
      statuses.push({ value: this.ride.status, text: TAXI_COURSE_RIDE_DICT[this.ride.status], disabled: true });
      return statuses;
    },
  },
};
</script>

<style lang="scss" scoped></style>
